import { css } from 'styled-components';

const variables = css`
  :root {
    /* Catppuccin Frappé */
    --dark-navy: #232634; /* Crust */
    --navy: #303446; /* Base */
    --light-navy: #414559; /* Surface0 */
    --lightest-navy: #51576d; /* Surface1 */
    --navy-shadow: rgba(35, 38, 52, 0.7);
    --dark-slate: #737994; /* Overlay0 */
    --slate: #a5adce; /* Subtext0 */
    --light-slate: #b5bfe2; /* Subtext1 */
    --lightest-slate: #c6d0f5; /* Text */
    --white: #c6d0f5; /* Text */
    --green: #a6d189; /* Green */
    --green-tint: rgba(166, 209, 137, 0.1);
    --pink: #f4b8e4; /* Pink */
    --blue: #8caaee; /* Blue */

    --font-sans: 'Calibre', 'Inter', 'San Francisco', 'SF Pro Text', -apple-system, system-ui,
      sans-serif;
    --font-mono: 'SF Mono', 'Fira Code', 'Fira Mono', 'Roboto Mono', monospace;

    --fz-xxs: 12px;
    --fz-xs: 13px;
    --fz-sm: 14px;
    --fz-md: 16px;
    --fz-lg: 18px;
    --fz-xl: 20px;
    --fz-xxl: 22px;
    --fz-heading: 32px;

    --border-radius: 4px;
    --nav-height: 100px;
    --nav-scroll-height: 70px;

    --tab-height: 42px;
    --tab-width: 120px;

    --easing: cubic-bezier(0.645, 0.045, 0.355, 1);
    --transition: all 0.25s cubic-bezier(0.645, 0.045, 0.355, 1);

    --hamburger-width: 30px;

    --ham-before: top 0.1s ease-in 0.25s, opacity 0.1s ease-in;
    --ham-before-active: top 0.1s ease-out, opacity 0.1s ease-out 0.12s;
    --ham-after: bottom 0.1s ease-in 0.25s, transform 0.22s cubic-bezier(0.55, 0.055, 0.675, 0.19);
    --ham-after-active: bottom 0.1s ease-out,
      transform 0.22s cubic-bezier(0.215, 0.61, 0.355, 1) 0.12s;
  }
`;

export default variables;
